export const PERMS = {
    READ: 'sales_types.read',
    UPDATE: 'sales_types.update',
    DELETE: 'sales_types.delete',
    CREATE: 'sales_types.create',
}
